import React from 'react';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import sprintf from 'sprintf';
import OptimizedImage from 'components/shared/OptimizedImage';

class SMCoverPhotoView extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  coverPhotoDidSelect(e) {
    e.preventDefault();
    if(this.props.delegate && typeof this.props.delegate.coverPhotoDidSelect === 'function'){
      this.props.delegate.coverPhotoDidSelect(e);
    }
  }

  render() {
    return(
      <div className="space-head__img">
        <a href="#" onClick={this.coverPhotoDidSelect.bind(this)}>
          <OptimizedImage
            src={SMFormatHelper.imageURLWithTransform(this.props.source, {width: 1200, height: 670})}
            alt={sprintf("%s のカバー写真", SMFormatHelper.roomName(this.props.room))}
           />
        </a>
        <a href="#" onClick={this.coverPhotoDidSelect.bind(this)} className="button-whiteblue space-head__showimage">写真を見る</a>
      </div>
    );
  }
}
export default SMCoverPhotoView;




// WEBPACK FOOTER //
// ./app/javascript/components/rooms/SMCoverPhotoView.jsx